<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">{{ type == 1 ? "添加商品" : "修改商品" }}</div>
          <div class="card-body">
            <Tabs v-model="tabsValue" :animated="false" type="card">
              <TabPane label="商品信息" name="tabs-1">
                <Form ref="create" :model="formValidate" :rules="ruleValidate" :label-width="100">
                  <FormItem label="商品名称" prop="name">
                    <Input v-model="formValidate.name" placeholder="请输入商品名称"></Input>
                  </FormItem>

                  <FormItem label="商品分类" prop="group" :class="!$store.state.isMobile ? 'w50' : ''">
                    <Select v-model="formValidate.group" placeholder="请选择商品分类">
                      <Option v-for="item in group" :key="item.id" :value="item.id">{{ item.name }}</Option>
                    </Select>
                  </FormItem>

                  <!-- <FormItem label="发货类型" prop="way">
                    <RadioGroup v-model="formValidate.way">
                      <Radio :label="1">自动发货</Radio>
                      <Radio :label="2">手动发货</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem
                    label="发货方式"
                    prop="logistics"
                    v-show="formValidate.way == 2"
                  >
                    <RadioGroup v-model="formValidate.logistics">
                      <Radio :label="0">无需物流</Radio>
                      <Radio :label="1">物流/快递</Radio>
                    </RadioGroup>
                  </FormItem> -->
                  <FormItem label="库存类型" prop="stocktype">
                    <RadioGroup v-model="formValidate.stocktype">
                      <Radio :label="1">有限库存</Radio>
                      <Radio :label="2">无限库存</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem label="单位" prop="unit" :class="!$store.state.isMobile ? 'w50' : ''">
                    <Input v-model="formValidate.unit" placeholder="请输入单位"></Input>
                  </FormItem>

                  <FormItem label="商品简介" prop="synopsis">
                    <Input v-model="formValidate.synopsis" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                      placeholder="一句话简介，20字以内"></Input>
                  </FormItem>

                  <FormItem label="商品封面图" prop="front">
                    <div class="pictrueBox">
                      <div class="pictrue" v-if="formValidate.front" @click="upload(1)">
                        <img :src="formValidate.front" alt="" />
                      </div>
                      <div class="upload" @click="upload(1)" v-else>
                        <Icon type="ios-camera" size="20"></Icon>
                      </div>
                    </div>
                  </FormItem>
                  <FormItem label="商品轮播图" prop="carousel">
                    <div class="tips">(最多5张)</div>
                    <div class="pictrueBox">
                      <div class="pictrue" v-for="(item, index) in formValidate.carousel" :key="item">
                        <img :src="item" alt="" />
                        <Button shape="circle" icon="md-close" size="small"
                          @click="formValidate.carousel.splice(index, 1)"></Button>
                      </div>

                      <div class="upload" @click="upload(5)">
                        <Icon type="ios-camera" size="20"></Icon>
                      </div>
                    </div>
                  </FormItem>
                  <FormItem label="一口价/元" prop="price" :class="!$store.state.isMobile ? 'w50' : ''">
                    <Input v-model="formValidate.price" placeholder="请输入一口价"></Input>
                  </FormItem>

                  <FormItem label="商品规格" prop="type">
                    <Alert v-if="$store.state.isMobile">请尝试左右滑动翻阅</Alert>
                    <Table :columns="columns" :data="data" border>
                      <template slot-scope="{ index }" slot="name">
                        <Input v-model="data[index].name"></Input>
                      </template>
                      <template slot-scope="{ index }" slot="price">
                        <InputNumber :min="0" v-model="data[index].price"></InputNumber>
                      </template>

                      <template slot-scope="{ index }" slot="stock">
                        <InputNumber :min="0" v-model="data[index].stock"></InputNumber>
                      </template>

                      <template slot-scope="{ index }" slot="minbuy">
                        <InputNumber :min="1" v-model="data[index].minbuy"></InputNumber>
                      </template>
                      <template slot-scope="{ index }" slot="maxbuy">
                        <InputNumber :min="0" v-model="data[index].maxbuy"></InputNumber>
                      </template>

                      <template slot-scope="{ row }" slot="status">
                        <i-switch v-model="row.status" :true-value="1" :false-value="0"
                          @on-change="statusChange(row.id, row.status)" />
                      </template>

                      <template slot-scope="{ row, index }" slot="action">
                        <Button type="error" title="删除此项" shape="circle" icon="md-trash"
                          @click="delNorms(index, row)"></Button>
                      </template>
                    </Table>

                    <div class="table-add" title="添加规格" @click="addNorms">
                      <Button type="primary" title="添加规格" shape="circle" icon="md-add"></Button>
                    </div>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="tabsValue = 'tabs-2'">下一步</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="商品详情" name="tabs-2">
                <Ueditor @content="content" :newContent="formValidate.details"></Ueditor>
                <div style="margin-top: 20px">
                  <Button type="default" @click="tabsValue = 'tabs-1'" style="margin-right: 10px">上一步</Button>
                  <Button type="primary" @click="tabsValue = 'tabs-3'">下一步</Button>
                </div>
              </TabPane>

              <TabPane label="其他设置" name="tabs-3">
                <Form :model="formValidate" :label-width="130">
                  <FormItem label="虚拟销量" prop="sales">
                    <InputNumber :min="0" v-model="formValidate.sales"></InputNumber>
                  </FormItem>
                  <FormItem label="排序" prop="sort">
                    <InputNumber :min="0" v-model="formValidate.sort"></InputNumber>
                  </FormItem>
                  <FormItem label="商品类别" prop="category" v-show="formValidate.way == 1"
                    :class="!$store.state.isMobile ? 'w50' : ''">
                    <Input v-model="formValidate.category" placeholder="请输入类别 如:卡密、兑换码等"></Input>
                  </FormItem>

                  <FormItem label="服务说明" prop="serve" :class="!$store.state.isMobile ? 'w50' : ''">
                    <Select v-model="formValidate.serve" filterable multiple allow-create>
                      <!-- <Option value="免登陆购买">免登陆购买</Option> -->
                      <Option v-for="item in formValidate.serve" :key="item" :value="item">{{item}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="折扣活动" prop="salesId">
                    <Select v-model="formValidate.salesId" :class="!$store.state.isMobile ? 'w50' : 'w80'"
                      placeholder="如需绑定折扣活动请选择">
                      <Option v-for="item in sales" :key="item.id" :value="item.id">{{ item.name }}</Option>
                    </Select>
                    <Button v-show="formValidate.salesId != ''" style="margin-left: 5px" type="error" title="清除绑定"
                      shape="circle" icon="md-trash" @click="formValidate.salesId = ''"></Button>
                  </FormItem>
                  <FormItem label="发货短信通知买家" prop="deliver_phone">
                    <i-switch v-model="formValidate.deliver_phone" :true-value="1" :false-value="0" />
                    <p style="font-size: 12px; color: #999">
                      * 开通此功能请先去短信配置里面配置短信接口参数；由用户下单时自由选择是否发送
                    </p>
                  </FormItem>
                  <FormItem label="发货短信通知费用" prop="deliver_phone_price" v-show="formValidate.deliver_phone == 1">
                    <InputNumber :min="0" :step="0.01" v-model="formValidate.deliver_phone_price"></InputNumber>
                    <p style="font-size: 12px; color: #999">* 不收费请填0</p>
                  </FormItem>
                  <FormItem label="发货至买家邮箱" prop="deliver_email">
                    <i-switch v-model="formValidate.deliver_email" :true-value="1" :false-value="0" />
                    <p style="font-size: 12px; color: #999">
                      * 开通此功能请先去邮箱配置里面配置发件邮箱参数；由用户下单时自由选择是否发送
                    </p>
                  </FormItem>


                  <FormItem label="推荐商品" prop="hot">
                    <i-switch v-model="formValidate.hot" :true-value="1" :false-value="0" />
                  </FormItem>
                  <!-- <FormItem label="是否开启评价" prop="appraise">
                    <i-switch
                      v-model="formValidate.appraise"
                      :true-value="1"
                      :false-value="0"
                    />
                  </FormItem> -->
                  <FormItem label="是否上架" prop="status">
                    <i-switch v-model="formValidate.status" :true-value="1" :false-value="0" />
                  </FormItem>

                  <FormItem>
                    <Button type="default" @click="tabsValue = 'tabs-2'" style="margin-right: 10px">上一步</Button>
                    <Button type="primary" :loading="loading" @click="type == 1 ? addSave() : editSave()">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
    <UploadPictures @use="use"></UploadPictures>
  </div>
</template>

<script>
  import {
    getGroup,
    postShop,
    getSales,
    getSingleShop,
    putShop,
    delNorms,
    putNormsStatus,
  } from "@/api/admin";
  export default {
    data() {
      return {
        tabsValue: "tabs-1",
        type: 1, //1添加  2修改
        group: [],
        sales: [],
        loading: false,
        formValidate: {
          name: "",
          group: "",
          way: 1,
          stocktype: 1,
          unit: "件",
          synopsis: "",
          front: "",
          carousel: [],
          price: "",
          details: "",
          sales: 0,
          sort: 0,
          serve: ["官方正品","自动发货","7天无理由"],
          salesId: "",
          hot: 0,
          category: "卡密",
          logistics: 0,
          appraise: 0,
          status: 1,
          deliver_phone: 0,
          deliver_phone_price: 0,
          deliver_email: 1
        },
        ruleValidate: {
          name: [{
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          }],
          group: [{
            required: true,
            type: "number",
            message: "请选择商品分类",
            trigger: "change",
          }, ],
          way: [{
            required: true,
            type: "number",
            message: "请选择发货类型",
            trigger: "change",
          }, ],
          stocktype: [{
            required: true,
            type: "number",
            message: "请选择库存类型",
            trigger: "change",
          }, ],
          logistics: [{
            required: true,
            type: "number",
            message: "请选择发货方式",
            trigger: "change",
          }, ],
          unit: [{
            required: true,
            message: "请输入单位",
            trigger: "blur"
          }],
          front: [{
            required: true,
            message: "请上传商品封面图",
            trigger: "blur"
          }, ],
          price: [{
            required: true,
            message: "请输入一口价",
            trigger: "blur"
          }],
        },
        columns: [{
            title: "规格名称",
            align: "center",
            minWidth: 120,
            slot: "name",
          },
          {
            title: "售价/元",
            align: "center",
            minWidth: 120,
            slot: "price",
          },
          // {
          //   title: "库存",
          //   align: "center",
          //   minWidth: 120,
          //   slot: "stock",
          // },
          {
            title: "起购数量",
            align: "center",
            minWidth: 120,
            slot: "minbuy",
          },
          {
            title: "限购数量 \n (0为不限购)",
            align: "center",
            minWidth: 120,
            slot: "maxbuy",
          },
          {
            title: "是否启用",
            align: "center",
            minWidth: 60,
            slot: "status",
          },
          {
            title: "操作",
            align: "center",
            minWidth: 60,
            slot: "action",
          },
        ],
        data: [{
          name: "",
          price: 1,
          stock: "",
          minbuy: 1,
          maxbuy: 0,
          goods_id: "",
          status: 1,
        }, ],
      };
    },
    created() {
      this._getGroup();
      this._getSales();
    },
    mounted() {
      if (this.$route.params.id) {
        this._getSingleShop(this.$route.params.id);
        this.type = 2;
      }
    },
    computed: {
      way() {
        return this.formValidate.way;
      },
    },
    watch: {
      way(newVal) {
        if (newVal == 2) {
          console.log(newVal);
          this.columns.splice(2, 0, {
            title: "库存",
            align: "center",
            minWidth: 120,
            slot: "stock",
          });
        } else {
          if (this.columns[2].title == "库存") {
            this.columns.splice(2, 1);
          }
        }
      },
      // 监听路由刷新
      $route: {
        handler: function (val, oldVal) {
          window.location.reload();
        },
        // 深度观察监听
        deep: true,
      },
    },

    methods: {
      // 新增保存
      addSave() {
        if (this.data.length == 0) {
          this.$Message.warning({
            background: true,
            content: "至少需要添加一种规格",
          });
          return;
        }
        this.loading = true
        this.$refs.create.validate((valid) => {
          if (valid) {
            postShop({
              name: this.formValidate.name,
              group: this.formValidate.group,
              way: this.formValidate.way,
              stocktype: this.formValidate.stocktype,
              logistics: this.formValidate.logistics,
              category: this.formValidate.category,
              appraise: this.formValidate.appraise,
              unit: this.formValidate.unit,
              synopsis: this.formValidate.synopsis,
              front: this.formValidate.front,
              carousel: this.formValidate.carousel,
              price: this.formValidate.price,
              details: this.formValidate.details,
              sales: this.formValidate.sales,
              sort: this.formValidate.sort,
              serve: this.formValidate.serve,
              hot: this.formValidate.hot,
              salesId: this.formValidate.salesId ?
                this.formValidate.salesId : null,
              status: this.formValidate.status,
              deliver_phone: this.formValidate.deliver_phone,
              deliver_phone_price: this.formValidate.deliver_phone_price,
              deliver_email: this.formValidate.deliver_email,
              norms: this.data,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this.$router.push('/shop/list')
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
              this.loading = false
            });
            
          } else {
            this.$Message.warning({
              background: true,
              content: "请先补全带*的必填项",
            });
            this.loading = false
          }
        });
      },
      // 修改保存
      editSave() {
        if (this.data.length == 0) {
          this.$Message.warning({
            background: true,
            content: "至少需要添加一种规格",
          });
          return;
        }
        this.loading = true
        this.$refs.create.validate((valid) => {
          if (valid) {
            putShop({
              id: this.formValidate.id,
              name: this.formValidate.name,
              group: this.formValidate.group,
              way: this.formValidate.way,
              stocktype: this.formValidate.stocktype,
              logistics: this.formValidate.logistics,
              category: this.formValidate.category,
              appraise: this.formValidate.appraise,
              unit: this.formValidate.unit,
              synopsis: this.formValidate.synopsis,
              front: this.formValidate.front,
              carousel: this.formValidate.carousel,
              price: this.formValidate.price,
              details: this.formValidate.details,
              sales: this.formValidate.sales,
              sort: this.formValidate.sort,
              serve: this.formValidate.serve,
              hot: this.formValidate.hot,
              salesId: this.formValidate.salesId ?
                this.formValidate.salesId : null,
              status: this.formValidate.status,
              deliver_phone: this.formValidate.deliver_phone,
              deliver_phone_price: this.formValidate.deliver_phone_price,
              deliver_email: this.formValidate.deliver_email,
              norms: this.data,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getSingleShop(this.$route.params.id);
                this.$router.push('/shop/list')

              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
              this.loading = false
            });
          } else {
            this.$Message.warning({
              background: true,
              content: "请先补全带*的必填项",
            });
            this.loading = false
          }
        });
      },
      // 调用上传组件
      upload(num) {
        this.$store.state.imgUsageType = num;
        this.$store.state.showBase = true;
      },
      // 编辑器传值
      content(val) {
        this.formValidate.details = val;
      },
      // 使用图片传值
      use(val) {
        console.log(val, 2222222);

        let long = val.length;
        if (this.$store.state.imgUsageType == 1) {
          // 封面图
          if (long == 1) {
            this.formValidate.front = val[0];
            this.$store.state.showBase = false;
          } else {
            this.$Message.warning({
              background: true,
              content: "最多选择1张图片",
            });
          }
        } else if (this.$store.state.imgUsageType == 0) {
          // 编辑器上传
          let htmlcode = "";
          val.map(function (item) {
            item = '<img src="' + item + '">';
            htmlcode = htmlcode + item;
          });
          console.log(htmlcode, 11111111111);
          this.$store.state.showBase = false;

          this.formValidate.details = this.formValidate.details + htmlcode;
          console.log(this.formValidate.details, 3333333333333333);
        } else {
          //轮播图
          if (long <= this.$store.state.imgUsageType) {
            if (this.formValidate.carousel.length + val.length > 5) {
              this.$Message.warning({
                background: true,
                content: "还可以再选择" +
                  (this.$store.state.imgUsageType -
                    this.formValidate.carousel.length) +
                  "张图片",
              });
            } else {
              let _this = this;
              val.map(function (item) {
                // item = window.global_url.Base_url + "/uploads/" + item;
                _this.formValidate.carousel.push(item);
              });
              this.$store.state.showBase = false;
            }
          } else {
            this.$Message.warning({
              background: true,
              content: "最多选择" + this.$store.state.imgUsageType + "张图片",
            });
          }
        }
      },
      // 添加规格
      addNorms() {
        this.data.push({
          name: "",
          price: "",
          stock: "",
          minbuy: "1",
          maxbuy: "0",
          goods_id: "",
          status: 1,
        });
      },
      // 修改规格状态
      statusChange(id, status) {
        console.log(id, status);
        if (this.type == 2) {
          putNormsStatus({
            id,
            status,
          }).then((res) => {
            if (res.code == 200) {
              this.$Message.success({
                background: true,
                content: status ? "已启用" : "已停用",
              });
              this._getData();
            } else {
              this.$Message.error({
                background: true,
                content: res.msg,
              });
            }
          });
        }
      },
      // 删除规格
      delNorms(i, row) {
        if (this.type == 1) {
          this.data.splice(i, 1);
        } else {
          if (this.data.length <= 1) {
            this.$Message.warning({
              background: true,
              content: "至少需要添加一种规格",
            });
            return;
          }
          this.$Modal.confirm({
            title: "删除确认",
            content: "删除后无法恢复，请确认是否继续？",
            onOk: () => {
              delNorms({
                id: row.id,
              }).then((res) => {
                if (res.code == 200) {
                  this.$Message.success({
                    background: true,
                    content: res.msg,
                  });
                  this._getSingleShop(this.$route.params.id);
                } else {
                  this.$Message.error({
                    background: true,
                    content: res.msg,
                  });
                }
              });
            },
          });
        }
      },
      // 获取分类列表
      _getGroup() {
        getGroup({
          pageIndex: 1,
          pageSize: 100,
          name: "",
        }).then((res) => {
          this.group = res.data.data;
        });
      },
      // 获取折扣活动列表
      _getSales() {
        getSales({
          pageIndex: 1,
          pageSize: 100,
          name: "",
        }).then((res) => {
          this.sales = res.data.data;
        });
      },

      //  获取商品信息
      _getSingleShop(id) {
        getSingleShop({
          id,
        }).then((res) => {
          if (res.code == 200) {
            this.formValidate = res.data;
            this.data = res.data.list;
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
            this.$router.push('/shop/list')
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  @deep: ~">>>";

  // th {
  //   background: #ffffff;
  // }
  .help {
    margin-left: 10px;
    font-size: 20px;
    vertical-align: middle;
  }

  .card-body {
    padding-top: 10px;
  }

  .w50 {
    width: 50%;
  }

  .w80 {
    width: 80%;
  }

  .tips {
    position: absolute;
    color: #999;
    top: 29px;
    left: -77px;
    font-size: 12px;
  }

  .table-add {
    cursor: pointer;

    width: 100%;
    padding: 5px;
    text-align: center;
    border-left: 1px solid #dcdee2;
    border-right: 1px solid #dcdee2;
    border-bottom: 1px solid #e8eaec;
  }

  .pictrueBox {
    display: block;

    .upload {
      display: inline-block;
      margin-right: 10px;
      width: 58px;
      height: 58px;
      line-height: 58px;
      border: 1px dotted rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      text-align: center;
    }

    .pictrue {
      width: 58px;
      height: 58px;
      display: inline-block;
      margin-right: 15px;
      vertical-align: middle;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        border-radius: 4px;
      }

      .ivu-btn {
        position: absolute;
        font-size: 12px !important;
        width: 20px;
        height: 20px;
        top: -6px;
        right: -6px;
      }
    }
  }
  /deep/.ivu-table-cell{
    white-space: pre-line;
  }
</style>